import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import ParityApp from './parityApp.jsx';
import './style.css';

class AppErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('AQENORA render error:', error, info); }
  render() {
    if (this.state.error) return <main className="fatalError"><h1>Não foi possível abrir a AQENORA</h1><p>O aplicativo encontrou um erro durante a inicialização.</p><pre>{String(this.state.error?.stack || this.state.error)}</pre><button className="btn primary" onClick={() => location.reload()}>Recarregar</button></main>;
    return this.props.children;
  }
}

const AUTH_URL = import.meta.env.VITE_AUTH_URL || 'http://127.0.0.1:8090';

function LocalLogin({onSuccess}) {
  const [email,setEmail]=useState('');
  const [tenantId,setTenantId]=useState(()=>localStorage.getItem('promptforge.tenant_id')||'');
  const [password,setPassword]=useState('');
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState('');
  const submit=async(e)=>{
    e.preventDefault(); setLoading(true); setError('');
    try {
      const response=await fetch(`${AUTH_URL}/login`,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({email,password,tenant_id:tenantId})
      });
      const data=await response.json().catch(()=>({}));
      if(!response.ok) throw new Error(data.detail || data.message || 'Usuário ou senha inválidos.');
      localStorage.setItem('promptforge.tenant_id',tenantId);
      sessionStorage.setItem('promptforge_access_token',data.access_token);
      sessionStorage.setItem('promptforge_local_user',JSON.stringify({email,tenant_id:tenantId}));
      onSuccess({email,tenant_id:tenantId});
    } catch(err) { setError(err.message || 'Não foi possível entrar.'); }
    finally { setLoading(false); }
  };
  return <main className="loginPage"><section className="loginCard"><div className="loginBrand"><span className="loginLogo"><img src="/favicon.svg" alt="AQENORA" /></span><div><h1>AQENORA</h1><p>Commerce Intelligence Platform · Ambiente protegido.</p></div></div><form onSubmit={submit}><label>E-mail<input autoFocus type="email" value={email} onChange={e=>setEmail(e.target.value)} required /></label><label>Workspace ID<input value={tenantId} onChange={e=>setTenantId(e.target.value)} required placeholder="UUID do workspace" /></label><label>Senha<input type="password" value={password} onChange={e=>setPassword(e.target.value)} required placeholder="Digite sua senha" /></label>{error&&<div className="loginError">{error}</div>}<button data-testid="login-button" className="btn primary loginButton" disabled={loading}>{loading?'Entrando…':'Entrar'}</button></form><small>Use o e-mail, a senha e o Workspace ID do proprietário cadastrado.</small></section></main>;
}

function Root() {
  const [session,setSession]=useState({loading:true,user:null,manager:null});
  const localMode=import.meta.env.VITE_LOCAL_MODE==='true' || !import.meta.env.VITE_OIDC_AUTHORITY;
  useEffect(()=>{
    let active=true;
    async function initialize(){
      if(localMode){
        const token=sessionStorage.getItem('promptforge_access_token');
        if(!token){ if(active)setSession({loading:false,user:null,manager:null}); return; }
        try{
          const response=await fetch(`${AUTH_URL}/protected`,{headers:{Authorization:`Bearer ${token}`}});
          if(!response.ok) throw new Error('expired');
          const user=JSON.parse(sessionStorage.getItem('promptforge_local_user')||'{}');
          if(active)setSession({loading:false,user,manager:null});
        }catch{ sessionStorage.clear(); if(active)setSession({loading:false,user:null,manager:null}); }
        return;
      }
      const {UserManager,WebStorageStateStore}=await import('oidc-client-ts');
      const manager=new UserManager({authority:import.meta.env.VITE_OIDC_AUTHORITY,client_id:import.meta.env.VITE_OIDC_CLIENT_ID,redirect_uri:`${location.origin}/callback`,post_logout_redirect_uri:`${location.origin}/`,response_type:'code',scope:'openid email profile',userStore:new WebStorageStateStore({store:sessionStorage})});
      if(location.pathname==='/callback'){await manager.signinRedirectCallback();location.replace('/');return;}
      const oidc=await manager.getUser();
      if(oidc&&!oidc.expired){sessionStorage.setItem('promptforge_access_token',oidc.access_token);if(active)setSession({loading:false,user:oidc.profile,manager});}
      else if(active)setSession({loading:false,user:null,manager});
    }
    initialize().catch(error=>{console.error(error);if(active)setSession({loading:false,user:null,manager:null,error});}); return()=>{active=false};
  },[localMode]);
  const logout=async()=>{sessionStorage.removeItem('promptforge_access_token');sessionStorage.removeItem('promptforge_local_user');if(localMode){setSession({loading:false,user:null,manager:null});return;}if(session.manager)await session.manager.signoutRedirect();};
  if(session.loading)return <main className="loginPage"><section className="loginCard"><p>Carregando sessão…</p></section></main>;
  if(session.error)return <main className="fatalError"><h1>Falha na autenticação</h1><pre>{String(session.error?.stack||session.error)}</pre><button className="btn primary" onClick={()=>location.reload()}>Recarregar</button></main>;
  if(!session.user){
    if(localMode)return <LocalLogin onSuccess={user=>setSession({loading:false,user,manager:null})}/>;
    return <main className="loginPage"><section className="loginCard"><h1>AQENORA</h1><p>Entre com segurança para acessar a plataforma.</p><button className="btn primary" onClick={()=>session.manager?.signinRedirect()}>Entrar</button></section></main>;
  }
  return <ParityApp user={session.user} onLogout={()=>{void logout();}}/>;
}
const rootElement=document.getElementById('root'); if(!rootElement)throw new Error('Elemento #root não encontrado.');
createRoot(rootElement).render(<AppErrorBoundary><Root/></AppErrorBoundary>);
